export const EPOCH_LENGTH = 30 * 60 // 30 minutes
